import {Tooltip, TooltipContent, TooltipTrigger} from "@/components/shadcn/tooltip.tsx";

export const MAX_VISIBLE = 5


export function ModuleIconList({children, restLabels}: { children: React.ReactNode[]; restLabels?: string[] }) {
  const total = children.length
  if (total === 0) return <span className="text-muted-foreground text-sm">—</span>

  const visible = children.slice(0, MAX_VISIBLE)
  const rest = total - MAX_VISIBLE

  return (
    <div className="flex items-center gap-1 overflow-hidden">
      {visible}
      {rest > 0 && (
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="flex-shrink-0 flex size-8 items-center justify-center rounded-md border bg-muted/40 text-xs text-muted-foreground cursor-default">
              +{rest}
            </span>
          </TooltipTrigger>
          <TooltipContent>
            <div className="flex flex-col gap-0.5">
              {restLabels?.map((label, i) => (
                <span key={i} className="text-xs">{label}</span>
              ))}
            </div>
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  )
}

